const defaultContext = ['mainCookie', 'abTests'];
const trackers = {
  structured: 'trackStructEvent',
  selfDescribing: 'trackSelfDescribingEvent',
};

export const greenGuideReadMoreClick = {
  tracker: trackers.structured,
  data: {
    category: 'green_guide',
    action: 'click',
    label: 'read_more',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const greenGuideHideMoreClick = {
  tracker: trackers.structured,
  data: {
    category: 'green_guide',
    action: 'click',
    label: 'hide_more',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const greenGuideKeepSearchingClick = {
  tracker: trackers.structured,
  data: {
    category: 'green_guide',
    action: 'click',
    label: 'keep_searching',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const greenGuideDisplay = {
  tracker: trackers.structured,
  data: {
    category: 'green_guide',
    action: 'display',
    label: 'sidebar',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const greenGuideRatingClick = (rating) => (
  {
    tracker: trackers.structured,
    data: {
      category: 'green_guide',
      action: 'click',
      label: 'feedback',
      property: rating,
      value: '0',
    },
    context: defaultContext,
  }
);

export const greenGuideRatingFeedback = (text, value) => (
  {
    tracker: trackers.structured,
    data: {
      category: 'green_guide',
      action: 'submit',
      label: 'feedback',
      property: text,
      value,
    },
    context: defaultContext,
  }
);
